import $ from "jquery";
import Marionette from "backbone.marionette";

import { getCommuteData, saveCommuteData } from "lib/util";

import rollbar from "../rollbar";

import templateAddress from "../templates/components/commuteAddress.jst";
import templateAddressInput from "../templates/components/commuteAddressInput.jst";

const CommuteAddressInput = Marionette.View.extend({
    template: templateAddressInput,
    ui: {
        commuteAddress: ".prefs-commute-address",
        commuteAddressDYK: ".prefs-commute-address-dym",
        commuteAddressDYKContainer: ".prefs-commute-address-dym-container",
        commuteAddressError: ".prefs-commute-address-container .form-error",
        commuteAddressInput: ".prefs-commute-address input",
        commuteAddressSaveLink: ".js-save-address",
    },
    events: {
        "click @ui.commuteAddressDYK": "onUseSuggestion",
        "click @ui.commuteAddressSaveLink": "onSaveAddress",
    },
    initialize() {
        this.commute = this.options.commute;
        this.shownSuggestion = false;
    },
    serializeData() {
        return {
            showSaveLink: this.options.showSaveLink,
        };
    },
    onRender() {
        window.initAutocomplete(this.ui.commuteAddressInput[0], {
            callback: (ac) => (this.autocomplete = ac),
        });
    },
    onSaveAddress(event) {
        event.preventDefault();

        this.trigger("save");
    },
    saveAddress() {
        const place = this.autocomplete && this.autocomplete.getPlace();
        let address;
        let latLng;

        if (place) {
            address = place.formatted_address;
            if (place.geometry) {
                latLng = place.geometry.location.toJSON();
            }

            this.trigger("submit", address, latLng);
            return;
        }

        address = this.ui.commuteAddressInput.val().trim();
        if (!address) {
            if (window.authUser && !this.commute.address) {
                $.modal.close();
            } else {
                this.ui.commuteAddressError.text("Please enter an address").fadeIn();
            }

            return;
        }

        this.ui.commuteAddressError.fadeOut();

        // Didn't change anything, so there's nothin' to do here.
        if (address === this.commute.address) {
            this.trigger("finish", this.commute);
            return;
        }

        if (this.shownSuggestion) {
            rollbar.debug("[COMMUTE] Forced pref commute address ignored suggestion");
            this.trigger("submit", address);
        } else {
            this.ui.commuteAddressSaveLink.loading(true);

            const acService = new window.google.maps.places.AutocompleteService();

            acService.getPlacePredictions(
                {
                    bounds: this.autocomplete.getBounds(),
                    input: address,
                    types: ["address"],
                    fields: window._includedFields,
                },
                (places, status) => {
                    this.ui.commuteAddressSaveLink.loading(false);

                    if (status !== "OK" || places.length === 0) {
                        rollbar.debug("[COMMUTE] Bad pref commute address no suggestions");
                        this.trigger("submit", address);
                    } else {
                        const suggestion = places[0];
                        this.ui.commuteAddressDYK.text(suggestion.description);
                        this.ui.commuteAddressDYK.data("address", suggestion.description);
                        this.ui.commuteAddressDYKContainer.fadeIn();
                        this.shownSuggestion = true;
                    }
                },
            );
        }
    },
    onUseSuggestion(event) {
        event.preventDefault();

        const address = $(event.currentTarget).data("address");

        this.ui.commuteAddressDYKContainer.fadeOut();
        this.ui.commuteAddressInput.val(address);

        // Could possibly use the Geocode API to get latlng here,
        // but we already do it on the backend so...
        this.trigger("submit", address);
    },
});

export default Marionette.View.extend({
    template: templateAddress,
    ui: {
        commuteExistingAddressContainer: ".prefs-commute-existing-address",
        commuteExistingAddress: ".prefs-commute-existing-address span",
        commuteAddressUpdateLink: ".js-update-address",
    },
    events: {
        "click @ui.commuteAddressUpdateLink": "onUpdateAddress",
    },
    initialize() {
        this.commute = window.commute || {};
        const storageVal = getCommuteData();

        if (storageVal) {
            Object.assign(this.commute, storageVal);
        }

        if (!this.commute.address && this.options.address) {
            this.commute.address = this.options.address;
        }
    },
    setAddress(address) {
        if (address) {
            if (this.ui.commuteExistingAddressContainer.length) {
                this.ui.commuteExistingAddressContainer.show();
                this.address.ui.commuteAddress.hide();
                this.ui.commuteExistingAddress.text(address);
            }

            this.address.ui.commuteAddressInput.val(address);
        } else {
            this.ui.commuteExistingAddressContainer.hide();
            this.address.ui.commuteAddress.show();
        }
    },
    onRender() {
        this.addressChanged = !this.commute.address;

        this.address = new CommuteAddressInput({
            el: this.options.addressEl,
            commute: this.commute,
            showSaveLink: !this.options.saveLink,
        });
        this.listenTo(this.address, "save", this.saveAddress);
        this.listenTo(this.address, "submit", this.submit);
        this.listenTo(this.address, "finish", this.finish);
        this.address.render();

        if (this.options.saveLink) {
            this.address.ui.commuteAddressSaveLink = this.options.saveLink;
        }

        this.setAddress(this.commute.address);
    },
    onUpdateAddress(event) {
        event.preventDefault();

        this.ui.commuteExistingAddressContainer.fadeOut(50, () => {
            this.address.ui.commuteAddress.fadeIn();
            this.addressChanged = true;
        });
    },
    saveAddress() {
        this.address.ui.commuteAddressError.text("");

        if (!this.addressChanged) {
            this.finish(this.commute);
            return;
        }

        this.address.saveAddress();
    },
    submit(address, latLng) {
        this.commute.address = address;

        const postData = { ...this.commute };
        if (latLng) {
            postData.lat = latLng.lat;
            postData.lng = latLng.lng;
        }

        this.address.ui.commuteAddressSaveLink.loading(true);

        $.ajax({
            url: "/api/hire/v1/commute/",
            method: "POST",
            data: JSON.stringify(postData),
            dataType: "json",
            contentType: "application/json",
        })
            .done((data) => {
                this.saveCommuteData(data);
            })
            .fail((response) => {
                if (response.status === 404) {
                    this.commute.geohash = "ooa";
                    this.saveCommuteData();
                    return;
                }

                this.address.ui.commuteAddressSaveLink.loading(false);
                this.address.ui.commuteAddressError
                    .html(
                        "Unable to use this address to calculate commute times. " +
                            "Please check that it's correct or try a nearby address instead.",
                    )
                    .fadeIn();
            });
    },
    saveCommuteData(data) {
        // Artificially wait and hope it computes what we need
        setTimeout(() => {
            const commuteData = {
                ...this.commute,
                ...data,
            };
            saveCommuteData(commuteData);
            this.finish(commuteData);
        }, this.options.artificialWaitTime || 2850);
    },
    finish(commuteData) {
        this.setAddress(commuteData.address);
        this.address.ui.commuteAddressSaveLink.loading(false);
        this.trigger("finish", commuteData);
    },
});
